import React, { useState } from 'react';
// import { useRouter } from 'next/router';
import Head from 'next/head';
import { useTranslation } from 'react-i18next';

import FadeIn from 'legacy/common/components/transition/FadeIn';
import Redirect from 'legacy/components/util/Redirect/Redirect';

import MoreOptionsModal from './components/MoreOptionsModal';
import useViewOrganization from './hooks/useViewOrganization';
import Header from '../../../components/view-org-layout/Header';
import DesktopView from '../../../components/view-org-layout/DesktopView';
import MobileView from '../../../components/view-org-layout/MobileView';
import ShareModal from '../../../components/view-org-layout/ShareModal';
import config from '../../../../config';
import useAuthenticationStatus from 'legacy/common/hooks/useAuthenticationStatus';
import useMembershipGateCheck from 'screens/organizations/hooks/useMembershipGateCheck';
// import MembershipGateSheet from './components/MembershipGateSheet';
import classNames from 'classnames';

const ViewOrganization = () => {
  const { t } = useTranslation(['organizations']);
  const { isAuthenticated } = useAuthenticationStatus();
  const isLoggedIn = isAuthenticated();
  // const { query } = useRouter();
  const {
    data: {
      organization,
      isLoading,
      isError,
      isDesktop,
      upcomingMemberships,
      isJoinBlocked
    },
    joinOrganization
  } = useViewOrganization();

  const blockedMessage = isJoinBlocked
    ? t('publicView.joinBlocked')
    : undefined;
  const [isMoreOptionsModalOpen, setIsMoreOptionsModalOpen] = useState(false);
  const [isShareModalOpen, setIsShareModalOpen] = useState(false);
  // const [isMembershipGateSheetOpen, setIsMembershipGateSheetOpen] = useState(
  //   Boolean(query['membership-required'])
  // );

  const { hasOngoingMembership, isLoading: isTempGateCheckLoading } =
    useMembershipGateCheck({
      group: organization
    });

  const toggleMoreOptionsModal = () => {
    setIsMoreOptionsModalOpen((moreOptionsOpen) => !moreOptionsOpen);
  };

  const toggleShareModal = () => {
    setIsShareModalOpen((shareModalOpen) => !shareModalOpen);
  };

  // const toggleMembershipGateSheet = () => {
  //   setIsMembershipGateSheetOpen((isOpen) => !isOpen);
  // };

  if (isError) {
    return <Redirect to="/404" />;
  }

  if (isLoading || !organization || isTempGateCheckLoading) {
    return null;
  }

  return (
    <>
      <Head>
        <title>{organization?.name || t('title')} | Bounce</title>
      </Head>
      {isLoggedIn && (
        <Header
          join={joinOrganization}
          isDesktop={isDesktop}
          isUserMember={organization.isUserMember}
          isUserPending={organization.isUserPending}
          isUserAdmin={organization.isUserAdmin}
          orgName={organization.name}
          iconUrl={organization.badgeImageUrl}
          title={t('title')}
          toggleShareModal={toggleShareModal}
          toggleMoreOptions={toggleMoreOptionsModal}
        />
      )}
      <div
        className={classNames('md:-mt-[10px]', {
          '-mb-[60px] -mt-[90px]': isLoggedIn // super hacky, but is required to mitigate public/private margins for header
        })}
      >
        <FadeIn>
          {isDesktop ? (
            <DesktopView
              toggleShareModal={toggleShareModal}
              name={organization.name}
              memberCount={organization.metadata.memberCount}
              memberPreview={organization.metadata.memberPreview}
              coverUrl={organization.coverImageUrl}
              badgeUrl={organization.badgeImageUrl}
              isUserPending={organization.isUserPending}
              join={joinOrganization}
              isUserMember={organization.isUserMember}
              address={organization.address}
              manageText={t('actions.manage')}
              isUserAdmin={organization.isUserAdmin}
              description={organization.description}
              editLink={`/organizations/${organization.id}/edit`}
              dashboardLink={`/organizations/${organization.id}/dashboard`}
              membersLink={`/organizations/${organization.id}/members`}
              organizationId={organization.id}
              hasOngoingMembership={hasOngoingMembership}
              upcomingMembership={upcomingMemberships}
              associationDependentId={organization?.associationDependentId}
              isJoinBlocked={isJoinBlocked}
              blockedMessage={blockedMessage}
            />
          ) : (
            <MobileView
              toggleShareModal={toggleShareModal}
              name={organization.name}
              memberCount={organization.metadata.memberCount}
              memberPreview={organization.metadata.memberPreview}
              coverUrl={organization.coverImageUrl}
              badgeUrl={organization.badgeImageUrl}
              isUserMember={organization.isUserMember}
              address={organization.address}
              manageText={t('actions.manage')}
              isUserAdmin={organization.isUserAdmin}
              description={organization.description}
              editLink={`/organizations/${organization.id}/edit`}
              dashboardLink={`/organizations/${organization.id}/dashboard`}
              membersLink={`/organizations/${organization.id}/members`}
              join={joinOrganization}
              isUserPending={organization.isUserPending}
              organizationId={organization.id}
              hasOngoingMembership={hasOngoingMembership}
              upcomingMembership={upcomingMemberships}
              associationDependentId={organization?.associationDependentId}
              isJoinBlocked={isJoinBlocked}
              blockedMessage={blockedMessage}
            />
          )}
        </FadeIn>
      </div>
      <MoreOptionsModal
        toggleShareModal={toggleShareModal}
        toggleMoreOptions={toggleMoreOptionsModal}
        visible={isMoreOptionsModalOpen}
      />
      <ShareModal
        visible={isShareModalOpen}
        onClose={toggleShareModal}
        shareLink={`${config.SITE_URL}organizations/${organization.id}`}
      />
      {/* <MembershipGateSheet
        visible={isMembershipGateSheetOpen}
        onClose={toggleMembershipGateSheet}
        organizationId={organization.id}
      /> */}
    </>
  );
};

export default ViewOrganization;
